module.exports = __webpack_public_path__ + "static/img/cjfw-companyStructure.5d551af9.png";